import { UserPreferenceContext } from '@/context/UserPreferenceContext';
import { useContext } from 'react';

const useUserPreferences = () => {
  return useContext(UserPreferenceContext);
};
export default useUserPreferences;
